import axios from 'axios';
import { createApiInstance, baseApiConfig } from './ApiConfig';

// Create auth API instance using shared configuration but without auto-logout for login
const authApi = axios.create(baseApiConfig);

// Create protected API instance with auto-logout for authenticated requests
const protectedApi = createApiInstance();

// Login function
export const login = async (username, password) => {
  const response = await authApi.post('/login', {
    username,
    password,
  });
  return response.data;
};

// Check login status function
export const checkLogin = async token => {
  const response = await protectedApi.get('/check_login', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// Refresh token function
export const refreshToken = async () => {
  const response = await protectedApi.post('/refresh');
  return response.data;
};

// User Management APIs (Admin only)
export const getUsers = async () => {
  const response = await protectedApi.get('/users');
  return response.data;
};

export const createUser = async userData => {
  const response = await protectedApi.post('/users', userData);
  return response.data;
};

export const deleteUser = async username => {
  const response = await protectedApi.delete(`/users/${username}`);
  return response.data;
};

export const updateUserPassword = async (username, passwordData) => {
  const response = await protectedApi.put(`/users/${username}/password`, passwordData);
  return response.data;
};

export const updateUsername = async (username, usernameData) => {
  const response = await protectedApi.put(`/users/${username}/username`, usernameData);
  return response.data;
};

export const updateUserRole = async (username, roleData) => {
  const response = await protectedApi.put(`/users/${username}/role`, roleData);
  return response.data;
};
